import {
   GET_DASHBOARD, GET_DASHBOARD_FAILURE, GET_DASHBOARD_SUCCESS
  } from "../types";
  
  export const getDashboard = (payload) => ({
    type: GET_DASHBOARD,
    payload
  });
  export const getDashboardSuccess = (payload) => ({
    type: GET_DASHBOARD_SUCCESS,
    payload,
  });
  export const getDashboardFailure = (payload) => ({
    type: GET_DASHBOARD_FAILURE,
    payload,
  });
  
